import React, { useState } from "react";
import { Image as ImageIcon } from "./Icons";

/*
 * Mostra uma imagem; se o arquivo ainda não existir no /public,
 * exibe um placeholder elegante indicando o nome esperado do arquivo.
 */
function Figura({ src, alt, caption }) {
  const [erro, setErro] = useState(false);
  const nomeArquivo = src.replace(/^\//, "");

  if (erro) {
    return (
      <div className="figure-ph">
        <div className="ic">
          <ImageIcon width={26} height={26} />
        </div>
        <p style={{ margin: "0 0 8px" }}>{alt}</p>
        <code>{nomeArquivo}</code>
      </div>
    );
  }

  return (
    <figure className="figure">
      <img src={src} alt={alt} loading="lazy" onError={() => setErro(true)} />
      {caption && <figcaption>{caption}</figcaption>}
    </figure>
  );
}

export default Figura;
